module.exports = __webpack_public_path__ + "components/media-kit/static/app-desktop-8cad50b30d1f13eec83801143b16cf5c.png";